import React from 'react'

import { Button } from 'primereact/button'
import { ItemTemplateOptions } from 'primereact/fileupload'

type Props = {
  fileObject: any
  props: ItemTemplateOptions
  onTemplateRemove: (onRemove: Function) => void
}

export const FileUploadItemTemplate: React.FC<Props> = ({
  fileObject,
  props,
  onTemplateRemove,
}) => {
  return (
    <div className="flex align-items-center flex-wrap">
      <div className="flex align-items-center">
        <img alt={''} src={fileObject.objectURL} width={100} />
        <span className="flex flex-column text-left">
          <span className="font-bold">{fileObject.name}</span>
          <span className="text-sm mt-1">{props.formatSize}</span>
          <span className="text-sm mt-1">
            {new Date().toLocaleDateString()}
          </span>
        </span>
      </div>
      <Button
        type="button"
        icon="pi pi-times"
        className="p-button-outlined p-button-rounded p-button-danger ml-auto"
        onClick={() => onTemplateRemove(props.onRemove)}
      />
    </div>
  )
}
